import React from "react";
import ServicesPageContent from "../components/Services";

const Services = () => {
  return (
    <div>
      <ServicesPageContent />
    </div>
  );
};

export default Services;
